import { isDesktop } from "react-device-detect";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { LoginState, getAccountState } from "../../redux/slices/accountSlice";
import { Outlet, useLocation } from "react-router-dom";
import { useOnMount } from "../../hooks/useOnMount";
import LoadingScreen from "../LoadingScreen";
import HomePageMobile from "./HomePageMobile";
import HelpModal from "../../components/Containers/HelpModal";
import {
  hasSubscription,
  isSubscriptionPaymentFailed,
  userPhoneVerificationStatus,
} from "@markit/common.utils";
import PaymentFailedButtonModal from "../../components/DisplayModal/UpdatePaymentInfoModal";
import { useNavigate } from "../../hooks/useNavigate";
import { NavigationId } from "../../navigation/AppParamList";
import CreatorModeWrapper from "../../components/CreatorDashboard/CreatorModeWrapper";
import { TwilioPhoneVerificationStatus } from "@markit/common.types";

const HomePage = () => {
  const navigate = useNavigate();
  const { account } = useSelector(getAccountState);
  const { accountData, loggedIn } = account;
  const { pathname } = useLocation();

  const [loading, setLoading] = useState(true);

  const [showHelpModal, setShowHelpModal] = useState<boolean>(false);
  const [paymentFailedVisible, setPaymentFailedVisible] = useState(false);

  useOnMount(() => {
    if (loggedIn !== LoginState.LOGGED_IN) {
      navigate(NavigationId.WELCOME);
    } else if (!accountData.inCreatorMode) {
      navigate("/");
    } else {
      setLoading(false);
    }
  });

  useEffect(() => {
    // Logic whether to show PaymentFailedSubscription
    if (
      pathname === NavigationId.HOME_CONVERSATIONS &&
      isSubscriptionPaymentFailed(accountData.customer.state)
    ) {
      setPaymentFailedVisible(true);
    }
    // Logic whether to navigate to finish onboarding (if subscription phone is unverified OR non-subscription user has not finished onboarding)
    const phoneVerificationStatus =
      userPhoneVerificationStatus(accountData) ||
      TwilioPhoneVerificationStatus.UNVERIFIED;
    if (
      isDesktop &&
      pathname !== NavigationId.HOME_FINISH_ONBOARDING &&
      ((hasSubscription(accountData) &&
        phoneVerificationStatus === TwilioPhoneVerificationStatus.UNVERIFIED) ||
        (!hasSubscription(accountData) &&
          accountData.inCreatorMode &&
          accountData.haveNotFinishedInitialStartup))
    ) {
      navigate(NavigationId.HOME_FINISH_ONBOARDING);
    }
  }, [accountData, navigate, pathname]);

  if (loading || !account.appInitialized) {
    return <LoadingScreen />;
  }

  return !isDesktop ? (
    <HomePageMobile />
  ) : (
    <CreatorModeWrapper>
      {paymentFailedVisible ? (
        <PaymentFailedButtonModal
          location="Initial Home Page"
          isVisible={paymentFailedVisible}
          setIsVisible={setPaymentFailedVisible}
          addOnClose={() => navigate("/home")}
        />
      ) : null}
      <Outlet />
      {/* Floating action button */}
      {/* {homePathTab(pathname) !== MenuItemLabel.CAMPAIGNS ? (
        <div
          className="FloatingActionButton"
          onClick={() => setShowHelpModal(true)}
        >
          <Icon icon="ion:help" height={27} />
        </div>
      ) : null} */}
      <HelpModal showModal={showHelpModal} setShowModal={setShowHelpModal} />
    </CreatorModeWrapper>
  );
};

export default HomePage;
